<template>
    <div class="pro">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "MasterDataManagement"
    }
</script>

<style scoped>

</style>